// @core/api/endpoints/authn/validate_sso_session.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateSSOSessionRequest,
  ValidateSSOSessionResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Validate SSO session
 * Checks if an SSO session is valid and returns the associated user information. Used by applications to verify SSO tokens before granting access.
 */
export async function ValidateSSOSession(
  data: ValidateSSOSessionRequest,
  options?: RequestOptions
): Promise<ValidateSSOSessionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/sso/sessions/validate`;
  const requestOptions = options;
  return client.post<ValidateSSOSessionResponse>(requestPath, data, requestOptions);
}
